import {
  AnonymizeCandidateModal,
  type AnonymizeCandidate,
} from './AnonymizeCandidateModal';

// Anonymize confirm for a table-row / More-menu modal slot. Every surface uses the same
// records-table modal, which lists the jobs / projects / flows the erase will strip.
interface AnonymizeFlowProps {
  candidate: AnonymizeCandidate;
  onClose: () => void;
  onSuccess?: () => void;
}

export const AnonymizeConsentFlow = ({
  candidate,
  onClose,
  onSuccess,
}: AnonymizeFlowProps) => (
  <AnonymizeCandidateModal
    candidate={candidate}
    modalActions={{ isOpen: true, onClose }}
    onSuccess={onSuccess}
  />
);
